module.exports = __webpack_public_path__ + "img/pos7_txt.8f9880f9.png";